import { render, staticRenderFns } from "./PetstarRibbon.vue?vue&type=template&id=83fa4a94"
import script from "./PetstarRibbon.vue?vue&type=script&lang=js"
export * from "./PetstarRibbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports